import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import "../SelectedComponent.scss";
import searchIcon from "../../../assets/images/search-normal.png";
import { useEffect, useState } from "react";
import axios from "axios";
import ErrorModal from "Components/Common/ErrorModal";
import Select from "react-select";
import { useParams } from "react-router-dom";
import index from "pages/Email/EmailTemplates/BasicAction";

const AddProductModal = ({ show, onCloseClick, productCampaign }: any) => {
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [isAdding, setIsAdding] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [type, setType] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [productData, setProductData] = useState<any[]>([]);
  const [categoryId, setCategoryId] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(1);
  const itemsPerPage = 10;
  const [categoriesOptionDv, setCategoryOptions] = useState<any[]>([]);
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });
  const { id } = useParams();

  const handleCheckboxChange = (product: any, isChecked: boolean) => {
    setSelectedProducts((prev) => {
      if (isChecked) {
        const alreadyExists = prev.some((item) => item._id === product._id);
        if (!alreadyExists) return [...prev, product];
        return prev;
      } else {
        return prev.filter((item) => item._id !== product._id);
      }
    });
  };

  const handleSelectAll = (e: any) => {
    if (e.target.checked) {
      setSelectedProducts(productData);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleAddProducts = async () => {
    if (selectedProducts.length === 0) {
      setShowModal({ isVisible: true, color: false });
      setErrorMessage("Please select at least one product.");
      return;
    }
    try {
      setIsAdding(true);
      const productIds = selectedProducts.map((product) => product._id);
      const response: any = await axios.put(
        `/api/v1/marketing-campaign/product?subProductIds=${productIds}&campaignId=${id}`
      );
      if (response.data && response.isSuccess) {
        setShowModal({ isVisible: true, color: true });
        setErrorMessage("Products added successfully!");
        setTimeout(() => {
          setShowModal({ isVisible: false, color: false });
          onCloseClick();
          setSelectedProducts([]);
        }, 1500);
      }
    } catch (error) {
      setShowModal({ isVisible: true, color: false });
      setErrorMessage("Failed to add products. Please try again.");
    } finally {
      setIsAdding(false);
    }
  };

  const getProductDataById = async (page: number) => {
    try {
      setIsLoading(true);
      const queryParams: Record<any, any> = {
        page,
        count: itemsPerPage,
        status: "active",
      };
      if (searchTerm) queryParams.keyword = searchTerm;
      if (type) queryParams.keywordType = type;
      if (categoryId) queryParams.categoryId = categoryId;
      const queryString = new URLSearchParams(queryParams).toString();
      const response: any = await axios.get(
        `/api/v1/marketing-campaign/product/seller?${queryString}`
      );
      if (response.data && response.isSuccess) {
        const fetchedProducts = response.data.data || [];
        setProductData(fetchedProducts);
        setTotalCount(response.data.totalCount || 0);
        const calculatedPages =
          Math.ceil(response.data.totalCount / itemsPerPage) || 1;
        setTotalPages(calculatedPages);
        const matchedProducts = fetchedProducts.filter((product: any) =>
          productCampaign?.some(
            (campaignProduct: any) => campaignProduct._id === product._id
          )
        );
        setSelectedProducts((prevSelected) => {
          const merged = [...prevSelected];
          matchedProducts.forEach((product:any) => {
            if (!merged.some((p) => p._id === product._id)) {
              merged.push(product);
            }
          });
          return merged;
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCategories = async () => {
    try {
      const response: any = await axios.get(
        `/api/v1/category/list?page=1&count=1000`
      );
      if (response.data && response.isSuccess) {
        const categoryOptions = response.data.data.map((category: any) => ({
          value: category._id,
          label: category.name,
        }));
        setCategoryOptions(categoryOptions);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (show) {
      getCategories();
      setCurrentPage(1);
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      getProductDataById(currentPage);
    }
  }, [searchTerm, type, categoryId, currentPage, show]);

  return (
    <>
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <Modal isOpen={show} centered className="AddProductMOdal">
        <ModalBody className="modal_Body">
          <img
            data-testing-id="closeIcon"
            onClick={() => onCloseClick(false)}
            className="closeIconModal"
            src={CLoseImg}
            alt=""
          />
          <div className="head">
            <div>
              <h1>Add Products</h1>
              <Select
                options={categoriesOptionDv}
                placeholder="Please select category or search with keyword"
                isSearchable
                className="select-different my-2"
                inputId="productSelect"
                onChange={(selectedOption: any) => {
                  const id = selectedOption?.value || null;
                  setCurrentPage(1);
                  setCategoryId(id);
                }}
              />
              {/* <div className="d-flex align-items-center gap-2">
                <input type="radio" />
                <p>Add products with Max. Campaign Entry Price</p>
              </div> */}
            </div>
            <div className="searchAndSelect">
              <select
                name="typeSelect"
                value={type}
                onChange={(e) => {
                  setCurrentPage(1);
                  setType(e.target.value);
                }}
              >
                <option value="productName">Product Name</option>
                <option value="sellerName">Seller Name</option>
                <option value="sku">Seller Sku</option>
                <option value="skuId">Sku Id</option>
              </select>
              <div className="input">
                <input
                  type="text"
                  placeholder='Click "enter" to search'
                  value={searchTerm}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearchTerm(e.target.value);
                  }}
                />
                <img src={searchIcon} alt="Search" />
              </div>
            </div>
          </div>
          <div className="AddProductListing_Main">
            <table className="w-100">
              <thead>
                <tr>
                  <th>
                    <div className="d-flex gap-2">
                      <input
                      data-testing-id="CheckboxSeller"
                        type="checkbox"
                        className="sellerCheckbox m-0 form-check-input"
                        onChange={(e) => {
                          handleSelectAll(e);
                        }}
                        checked={
                          productData?.length > 0 &&
                          productData.every((product: any) =>
                            selectedProducts.some(
                              (selected: any) => selected._id === product._id
                            )
                          )
                        }
                      />
                      <p>Basic Info</p>
                    </div>
                  </th>
                  <th>Category Name</th>
                  <th>Current Price</th>
                  <th>Current Stock</th>
                </tr>
              </thead>
              <tbody>
                {productData?.length > 0 &&
                  productData.map((product: any, index: any) => (
                    <tr key={product._id}>
                      <td>
                        <div className="d-flex gap-2">
                          <input
                            type="checkbox"
                            data-testing-id={"CheckboxSeller " + index}
                            className="sellerCheckbox m-0 form-check-input"
                            checked={selectedProducts.some(
                              (p) => p._id === product._id
                            )}
                            onChange={(e) => {
                              handleCheckboxChange(product, e.target.checked);
                            }}
                          />
                          <div className="profile d-flex align-items-center gap-2">
                            <img
                              src={product.image}
                              width={50}
                              height={50}
                              alt={product.image}
                            />
                            <div>
                              <p>{product.nameEn}</p>
                              <div className="d-flex gap-2 py-1">
                                <h5>
                                  Seller SKU:{" "}
                                  <span className="fw-bold">
                                    {product.sellerSKU}
                                  </span>
                                </h5>
                                <i
                                  className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    navigator.clipboard.writeText(
                                      product.sellerSKU
                                    );
                                    setShowModal({
                                      isVisible: true,
                                      color: true,
                                    });
                                    setErrorMessage("Seller SKU Copied!");
                                    setTimeout(() => {
                                      setShowModal({
                                        isVisible: false,
                                        color: false,
                                      });
                                    }, 1000);
                                  }}
                                ></i>
                              </div>
                              <div className="d-flex gap-2">
                                <h5>
                                  SKU ID:
                                  <span className="fw-bold">{product._id}</span>
                                </h5>
                                <i
                                  className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    navigator.clipboard.writeText(product._id);
                                    setShowModal({
                                      isVisible: true,
                                      color: true,
                                    });
                                    setErrorMessage("SKU ID Copied!");
                                    setTimeout(() => {
                                      setShowModal({
                                        isVisible: false,
                                        color: false,
                                      });
                                    }, 1000);
                                  }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-secondary fw-bold">
                          {typeof product.category === "object"
                            ? product.category?.name
                            : product.category}
                        </p>
                      </td>
                      <td>
                        <p>{product.price}</p>
                      </td>
                      <td>
                        <p>{product.stock}</p>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <div className="paginationDv">
              <div className="paginationDv d-flex justify-content-end">
                <nav aria-label="Page navigation">
                  <ul className="pagination detailPagepagi m-0">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        style={{ height: "26px", border: "none" }}
                      >
                        <i
                          className="bx bxs-left-arrow"
                          style={{ height: "11px" }}
                        ></i>
                      </button>
                    </li>

                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                      const startPage = Math.max(
                        Math.min(currentPage - 2, totalPages - 4),
                        1
                      );
                      const page = startPage + i;
                      if (page > totalPages) return null;
                      return (
                        <li
                          key={page}
                          className={`page-item ${
                            currentPage === page ? "active" : ""
                          }`}
                        >
                          <button
                          data-testing-id="AddProduct"
                            className="page-link orderPg"
                            onClick={() => setCurrentPage(page)}
                            style={{ height: "26px" }}
                          >
                            {page}
                          </button>
                        </li>
                      );
                    })}

                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        data-testing-id="NavbarOrder"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        style={{ height: "26px", border: "none" }}
                      >
                        <i
                          className="bx bxs-right-arrow"
                          style={{ height: "11px" }}
                        ></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <button
              className="button"
              data-testing-id="AddProduct_Plus"
              disabled={isAdding}
              onClick={handleAddProducts}
            >
              {isAdding ? "Adding..." : "+ Add Products"}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

AddProductModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.bool,
  productCampaign: PropTypes.any,
};

export default AddProductModal;
